const state = {
    data: []
}

const mutations = {
    storeStockRegisters (state, payload) {
        state.data = payload
    },
    storeStockRegister (state, payload) {
        if (payload.status) {
            state.data.map(item => item.status = false)
        }

        state.data.unshift(payload)
    },
    updateStockRegister (state, payload) {
        let curSR = state.data.find(item => item.id === payload.id)

        if (payload.status) {
            state.data.map(item => item.status = false)
        }

        curSR = payload
    },
    changeStockRegisterStatus (state, payload) {
        const curSR = state.data.find(item => item.id === payload.id)

        state.data.map(item => item.status = false)
        curSR.status = payload.status
    },
    deleteStockRegister (state, payload) {
        state.data = state.data.filter(item => item.id !== payload.id)
    }
}

const actions = {}

const getters = {
    getStockRegisters: state => state.data
}

export default {
    state,
    mutations,
    actions,
    getters
}
